import React from 'react';
import { Layer, Box, Text, Anchor } from 'grommet';

import useTranslation from 'next-translate/useTranslation';
import { BlockedCameraIcon } from '../icons';

const PermissionRequired = ({ setShow }) => {
	const { t } = useTranslation('default');
	return (
		<Layer onEsc={() => setShow(false)} onClickOutside={() => setShow(false)}>
			<Box pad="large">
				<Text weight="bold">{t('modals.permission_dismissed')}</Text>
				<Text margin={{ top: '10px', bottom: '10px' }}>
					{t('modals.permission_dismissed_description')}
					<BlockedCameraIcon />
				</Text>
				<Anchor
					onClick={() => setShow(false)}
					size="xsmall"
					label={t('continue')}
				/>
			</Box>
		</Layer>
	);
};

export default PermissionRequired;
